import { PropertyType } from 'esa-ui-library/lib/types';
import { reportConstants } from '../../constants/reports';
import { TableHeaderType, formatToISO } from '../../../common';

export const getFiltersUrl = (filters: PropertyType[]): string => {
	const urlFragments: string[] = [];
	const searchValueObject = filters.find((f) => f.name === 'q');
	const hasTransactionID = !!filters.find((f) => f.value === 'transaction_ids');
	const hasThirdPartyTrxID = !!filters.find((f) => f.value === 'thirdparty_trx_ids');
	const hasSessionID = !!filters.find(
		(f) => f.value === 'session_ids' || f.value == 'aams_session_ids' || f.value === 'partner_session_ids'
	);

	// Transaction id filter recived as searchType but has to be sent as transaction_ids='values'
	// so additional formatting is needed, same for session_ids
	filters.forEach((f) => {
		if (
			(f.value !== 'transaction_ids' &&
				f.value !== 'thirdparty_trx_ids' &&
				f.value !== 'session_ids' &&
				f.value != 'aams_session_ids' &&
				f.value !== 'partner_session_ids' &&
				f.value != 'round_ids' &&
				f.name !== 'q') ||
			(f.name === 'q' && !hasTransactionID && !hasThirdPartyTrxID && !hasSessionID)
		) {
			const value = f.name == 'start_date' || f.name == 'end_date' ? formatToISO(f.value) : f.value;
			urlFragments.push(`${f.name}=${value}`);
		} else if (
			(f.value === 'transaction_ids' && searchValueObject?.value) ||
			(f.value === 'thirdparty_trx_ids' && searchValueObject?.value) ||
			(f.value === 'session_ids' && searchValueObject?.value) ||
			(f.value === 'aams_session_ids' && searchValueObject?.value) ||
			(f.value === 'partner_session_ids' && searchValueObject?.value) ||
			(f.value === 'round_ids' && searchValueObject?.value)
		) {
			urlFragments.push(`${f.value}=${searchValueObject?.value}`);
		}
	});
	const fitlersQuery = `?${urlFragments.join('&')}`;
	return fitlersQuery;
};

export const filterTransactionFieldsByEnv = (fields: TableHeaderType[]): TableHeaderType[] => {
	let result = [...fields];
	if (!process.env.REACT_APP_SITE_TITLE?.includes('Italy')) {
		result = result.filter(
			(f) => f.label !== reportConstants.REPORT_AAMS_TICKET_ID && f.label !== reportConstants.REPORT_SESSION_TYPE
		);
	} else {
		result = result.filter(
			(f) => f.label !== reportConstants.REPORT_HAND_DETAILS && f.label !== reportConstants.REPORT_AAMS_TICKET_ID
		);
	}
	return result;
};
